/**
 * A page's header controls (Add, search, columns, back…), rendered where its host asks.
 *
 * Standing alone a master page shows them in its own header. Hosted inside a page that already
 * has a header — Recipe Building Blocks shows each master under its own tabs and pills — the
 * host provides a slot and the controls are portalled into it, so the master's heading (which
 * would only repeat the selected pill) is not needed at all. One component, so the 16 masters
 * do not each learn where they are hosted.
 */
import React, { createContext, useContext } from "react";
import { createPortal } from "react-dom";

/** The DOM element the controls go into, or null when the page is not hosted. */
export const HeaderActionsContext = createContext(null);

/** True when the page is hosted (its own heading is not shown). */
export const useHostedHeader = () => !!useContext(HeaderActionsContext);

export default function HeaderActions({ children }) {
  const slot = useContext(HeaderActionsContext);
  return slot ? createPortal(children, slot) : children;
}
